import { queryOptions } from "@tanstack/react-query";

import { fetchCodelist, fetchProduct, fetchStructure } from "@/lib/api";

/** One title; the route loads it while the page is loaded (B10). */
export const productQuery = (id: number) =>
  queryOptions({ queryKey: ["products", id], queryFn: () => fetchProduct(id) });

/** Structure of the ONIX 3.1 elements for the editor; fixed per release. */
export const structureQuery = queryOptions({
  queryKey: ["structure"],
  queryFn: fetchStructure,
  staleTime: Infinity,
});

/** An EDItEUR code list; fixed per issue. */
export const codelistQuery = (list: number) =>
  queryOptions({
    queryKey: ["codelist", list],
    queryFn: () => fetchCodelist(list),
    staleTime: Infinity,
  });
